module.exports = __webpack_public_path__ + "img/srf.85aaacb.png";